import * as React from 'react';

import { IBackendCartEntries } from '@rbi-ctg/menu';
import { CartEntryType } from 'utils/cart/types';

import { EntryDescriptionRow } from './cart-entry.styled';

const resolveEntryChild = (
  entry: IBackendCartEntries,
  currencyFormatter: Function,
  showAllPrices: boolean
) => {
  if (!entry.children) {
    return null;
  }

  const resolveChild = (
    child: IBackendCartEntries,
    i: number,
    parent?: IBackendCartEntries
  ): React.ReactNode => {
    const hasChildren = Array.isArray(child.children) && child.children.length > 0;

    const key = `${child.lineId ?? child.sanityId ?? child.name ?? 'row'}-${i}`;
    const parentIsNotMainItem = parent?.type === CartEntryType.comboSlot;
    const shouldShowSelf = parentIsNotMainItem && child.type === CartEntryType.item;

    // Fix for missing combo selections (e.g., "Side Salad") - the previous logic only rendered leaf nodes,
    // so items with children (like a salad with dressing) were skipped. This ensures we render items that
    // belong to a ComboSlot (sides, drinks, etc.) even if they have children, while keeping other behavior unchanged.
    const selfRow =
      shouldShowSelf && child.name !== 'Combo Sides' ? (
        <EntryDescriptionRow key={`${key}-self`}>
          {child.name}
          {(child.type === CartEntryType.itemOptionModifier || showAllPrices) && child.price
            ? ` - ${currencyFormatter(child.price)}`
            : null}
        </EntryDescriptionRow>
      ) : null;

    if (!hasChildren) {
      return (
        selfRow ?? (
          <EntryDescriptionRow key={key}>
            {child.name !== 'Combo Sides' && child.name}
            {(child.type === CartEntryType.itemOptionModifier || showAllPrices) && child.price
              ? ` - ${currencyFormatter(child.price)}`
              : null}
          </EntryDescriptionRow>
        )
      );
    }

    return (
      <React.Fragment key={key}>
        {selfRow}
        {child.children!.map((g, idx) => resolveChild(g, idx, child))}
      </React.Fragment>
    );
  };

  return entry.children.map((child, i) => resolveChild(child, i, entry));
};

export default resolveEntryChild;
